<template>
	<div>
		<v-expand-transition>
			<uploader v-if="uploadToggle" v-model="uploading" dialog @uploaded="uploadFiles" />
		</v-expand-transition>

		<files-table :files="files">
			<v-btn rounded color="success" elevation="0" @click="uploadToggle = !uploadToggle">
				<v-icon left>mdi-file-plus-outline</v-icon>
				Upload Files
			</v-btn>
		</files-table>
	</div>
</template>
<script>
import FilesTable from '@/Pages/Backend/Files/Table'
import Uploader from '@/Pages/Backend/Components/Uploader'

export default {
	components: {
		FilesTable,
		Uploader
	},
	props: {
		files: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			projectId: this.$page.props.project.id,
			uploadToggle: false,
			uploading: null
		}
	},
	methods: {
		uploadFiles (files) {
			this.uploading = true

			const route = this.route('files.store')
			const data = {
				uploads: files,
				model: 'project',
				'model-id': this.projectId
			}

			this.$inertia.post(route, data, {
				only: ['files', 'counts', 'flash'],
				onFinish: () => this.uploading = false
			})
		}
	}
}
</script>
